class NoCardsView {
  constructor({ el }) {
    this.el = el;
  }

  render(html) {
    const elementSelector = document.querySelector(this.el);
    if (elementSelector) {
      elementSelector.innerHTML = html;
    }
  }
}

module.exports = NoCardsView;
